import { render, staticRenderFns } from "./UpdateReceptionProducts.vue?vue&type=template&id=9cc2c968&scoped=true"
import script from "./UpdateReceptionProducts.vue?vue&type=script&lang=js"
export * from "./UpdateReceptionProducts.vue?vue&type=script&lang=js"
import style0 from "./UpdateReceptionProducts.vue?vue&type=style&index=0&id=9cc2c968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc2c968",
  null
  
)

export default component.exports